var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeakerOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.177 15.6199C19.4269 15.6199 19.6678 15.5263 19.8521 15.3576L24.3249 11.2643C24.9665 10.6771 26 11.1323 26 12.002V27.9972C26 28.8378 25.0258 29.3033 24.3718 28.7752L20.3552 25.5318C20.1773 25.3882 19.9556 25.3098 19.7269 25.3098H15C14.4477 25.3098 14 24.8621 14 24.3098V16.6199C14 16.0676 14.4477 15.6199 15 15.6199H19.177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22C28.5774 21.597 28.9655 20.8473 28.9655 19.9891C28.9655 19.1461 28.591 18.4079 28.0305 18M30.1724 23.5C31.1829 22.7947 31.8621 21.4829 31.8621 19.981C31.8621 18.5057 31.2067 17.2138 30.2257 16.5M32.1034 26C33.8357 24.7909 35 22.542 35 19.9674C35 17.4384 33.8766 15.2236 32.1948 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOn);
export default __webpack_public_path__ + "static/media/speaker-on.e500f47e9152afcf9efb456f36230718.svg";
export { ForwardRef as ReactComponent };